<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-15 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew">
                    <span>Auction</span>
                    <a>Preview Auction</a>
                </div>
            </div>
            <div>
                <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallInProgress">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b"
                        style="margin: 0 auto;" />
                </div>
                <div v-else-if="!ajaxCallInProgress" class="create-auction-container w-100 pb-4">
                    <!-- Auction Information Section -->
                    <div class="main-div">
                        <div class="create-auction-header d-flex align-items-center justify-content-between text-flow">
                            <span class="fs-14  pl-3 text-white ml-3">Auction Information</span>
                            <span class="pointer ml-2" @click="showAuctionInfoData()">
                                <i v-if="!showAuctionInfo" class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="showAuctionInfo" class="pl-10 pr-10 pt-6">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="w-100">
                                        <span class="input-label">Auction Name</span>
                                        <div class="d-flex align-content-center mt-2">
                                            <input type="text" autocomplete="off" name="auction_name" v-validate="'required'" class="input-field input-width" maxlength="100" v-model="auction_name" placeholder="Auction Name" disabled/>
                                        </div>
                                        <div class="text-right pr-10">
                                            <span class="float-left text-danger mb-3" v-show="errors.has('auction_name')">Auction Name is Required</span>
                                        </div>
                                        <div class="text-right mt-1">
                                            <span class="input-field-length float-right">{{ auction_name.length }}/100</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="w-100">
                                        <span class="input-label">Auction Creator</span>
                                        <div class="d-flex align-content-center mt-2">
                                            <input type="text" autocomplete="off" disabled name="auction_creator" class="input-field input-width" v-model="auction_creator" placeholder="Creator Name"/>
                                            <span class="mt-2 ml-1">
                                                <span class="mt-3"><i class="icon text-green icon-check-circle"></i></span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <span class="input-label">
                                        Creation Date
                                    </span>
                                    <div class="d-flex align-items-center mt-2">
                                        <date-picker v-model="creation_date" name="creation_date"
                                            disabled
                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                            format="MM-DD-YYYY" value-type="format" type="date" lang="en"
                                            placeholder="Select Creation Date"
                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                        </date-picker>
                                        <span class="mt-1"><i class="icon text-green icon-check-circle"></i></span>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-8 col-md-8 col-sm-8">
                                            <span class="input-label">
                                                Auction Opening Date
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <date-picker v-model="auction_opening_date" name="auction_opening_date"
                                                    :not-before="new Date()"
                                                    @change="checkOpeningTime()"
                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                    format="MM-DD-YYYY" value-type="format" type="date" lang="en"
                                                    placeholder="Select Date" disabled
                                                    :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4">
                                            <span class="input-label">
                                                Time
                                            </span>
                                            <el-select
                                                name="auction_opening_time" class="mt-2 schedule_time w-100" v-model="auction_opening_time"
                                                style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                                placeholder="Select Time"
                                                @change="checkClosingTime()" disabled
                                                :popper-append-to-body="false">
                                                <el-option v-for="(item, index) in opening_time_format" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-8 col-md-8 col-sm-8">
                                            <span class="input-label">
                                                Auction Closing Date
                                            </span>
                                            <div class="d-flex align-items-center mt-2">
                                                <date-picker v-model="auction_closing_date" name="auction_closing_date"
                                                    :not-before="auction_opening_date"
                                                    @change="checkClosingTime()" disabled
                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                    format="MM-DD-YYYY" value-type="format" type="date" lang="en"
                                                    placeholder="Select Date"
                                                    :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                </date-picker>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-4">
                                            <span class="input-label">
                                                Time
                                            </span>
                                            <el-select
                                                name="auction_closing_time" class="mt-2 schedule_time w-100" v-model="auction_closing_time"
                                                style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                                placeholder="Select Time" disabled
                                                :popper-append-to-body="false">
                                                <el-option v-for="(item, index) in closing_time_format" :key="index"
                                                    :label="item" :value="item">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12 mt-6">
                                    <span class="input-label">
                                        Description
                                    </span>
                                    <div class="d-flex align-items-center">
                                        <textarea-autosize class="digi-textarea white-background bordered" disabled placeholder="Add Description" maxlength="1000" v-model="description" style="height: 44px !important;overflow: overlay !important;"/>
                                    </div>
                                    <div class="text-right mt-1">
                                        <span class="input-field-length float-right">{{ description.length }}/1000</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="create-auction-header d-flex align-items-center justify-content-between text-flow mt-6">
                            <span class="fs-14  pl-3 text-white ml-3">Auctions Items Details</span>
                            <span class="pointer ml-2" @click="showAuctionItemsDetals()">
                                <i v-if="!showAuctionItems" class="icon-chevron-double-down text-white fw-500 fs-20"></i>
                                <i v-else class="icon-chevron-double-up text-white fw-500 fs-20"></i>
                            </span>
                        </div>
                        <div v-if="showAuctionItems">
                            <div class="pl-10 pr-10 pt-6" v-for="(table, table_index) in auction_table" :key="table_index">
                                <div class="table-div mt-4 p-4">
                                    <div v-if="table.table_data.length == 0">
                                        <div class="table-name-section mt-8 text-white fs-14 fw-600 pt-2 pl-4">
                                            Action Table
                                        </div>
                                        <div class="text-blace fs-14 mt-6 fw-500 d-flex justify-content-center align-items-center" style="border: 1px solid black; border-radius: 5px; height: 150px;">No Tables added yet!</div>
                                    </div>
                                    <div v-else>
                                        <div class="table-name-section mt-8">
                                            <input type="text" autocomplete="off" name="columns" disabled class="table-input-field" v-model="table.table_name" placeholder="Enter Name" />
                                        </div>
                                        <div style="overflow: auto;">
                                            <table class="auction-data-table mt-10" style="width: 100% !important;text-align: left;">
                                                <thead>
                                                    <tr>
                                                        <th v-for="(headingName, heading_index) in table.header_data" :key="heading_index">
                                                            {{ headingName }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, row_index) in table.table_data"
                                                        :key="row_index">
                                                        <td style="height: 38px;" class="pl-7" v-for="(col_data, col_index) in table.header_data" :key="col_index">
                                                            <input type="text" class="table-list" disabled v-model="row[col_data]" />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="disableButtonAndDisplayLoader == false" class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-2">
                        <button class="btn mt-2 ml-6 new-back-button" @click="gotoBack()">Back</button>
                        <button class="btn mt-2 ml-6 new-save-button" @click="saveAuction()">Update</button>
                    </div>
                    <div v-else class="d-flex flex-wrap align-items-center justify-content-center mb-4 mt-2">
                        <button class="btn mt-2 ml-6 new-back-button" disabled style="border: none !important;">Back</button>
                        <button class="btn mt-2 ml-6 new-save-button" style="position: relative;" disabled>Update
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import auction from "../mixins/auction.js"
import { HalfCircleSpinner } from "epic-spinners";
import { HollowDotsSpinner } from "epic-spinners";
import moment from 'moment';
import { SweetModal } from 'sweet-modal-vue';
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    mixins: [auction],
    data(){
        return {
            auction_table: [{
                rows: null,
                columns: null,
                table_name: "",
                table_data: [],
            }],
            ajaxCallInProgress: false,
            disableButtonAndDisplayLoader: false,
            showAuctionInfo: true,
            showAuctionItems: true,
            auction_name: "",
            auction_creator: "",
            creation_date: moment(new Date().toUTCString()).format("MM-DD-YYYY"),
            auction_opening_date: "",
            auction_opening_time: "",
            auction_closing_date: "",
            auction_closing_time: "",
            opening_time_format: [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            closing_time_format: [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ],
            description: "",
            auction_template_data: {},
            success_msg: "",
            warning_msg: "",
        }
    },
    components: {
            HalfCircleSpinner,
            SweetModal,
            HollowDotsSpinner
        },
    methods: {
        addTableCells(index){
            for (let i = 0; i < this.auction_table[index].rows; i++) {
                let cell = {};
                for (let j = 0; j < this.auction_table[index].columns; j++) {
                    cell['col_' + (j+1)] = ""
                }this.auction_table[index].table_data.push(cell);
            }
        },
        addTable(){
            this.auction_table.push({
                rows: null,
                columns: null,
                table_name: "",
                table_data: [],
            })
        },
        gotoBack(){
            this.$router.push('/auction/Edit/'+this.$route.params.id)
            setTimeout(() => {
                EventBus.$emit("back_from_preview_auction")
            }, 1000);
        },
        //Api call to save edited auction data
        saveAuction(){
            this.$validator.validateAll().then(async result => {
                if(result == true){
                    try{
                        this.disableButtonAndDisplayLoader = true
                        let response = await this.editAuction(this.$route.params.id, this.auction_template_data)
                        this.success_msg = response.message
                        this.$refs.success_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                            this.$router.push({
                                path: '/auction/listview'
                            })
                            this.disableButtonAndDisplayLoader = false
                        }, 3000);
                    } catch(error){
                        this.warning_msg = error
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                            this.disableButtonAndDisplayLoader = false
                        }, 3000);
                    }
                }
            this.disableButtonAndDisplayLoader = false
            })
        },
        showAuctionInfoData(){
            if (this.showAuctionInfo == true){
                this.showAuctionInfo = false;
            } else {
                this.showAuctionInfo = true
            } 
        },
        showAuctionItemsDetals(){
            if (this.showAuctionItems == true){
                this.showAuctionItems = false;
            } else {
                this.showAuctionItems = true
            } 
        },
        checkOpeningTime(){
            var curr_date = moment(new Date().toUTCString()).format("MM-DD-YYYY")
            this.auction_opening_time = "";
            this.auction_closing_date = "";
            this.auction_closing_time = "";
            this.opening_time_format = [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ]
            if(this.auction_opening_date == curr_date){
                var temp_start_time = ""
                var curr_time = moment(new Date().toUTCString()).format("HH:mm");
                if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                    temp_start_time = curr_time.slice(0,3) + '00'
                } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                    temp_start_time = curr_time.slice(0,3) + '15'
                } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                    temp_start_time = curr_time.slice(0,3) + '30'
                } else if(parseInt(curr_time.substring(3)) >= 45){
                    temp_start_time = curr_time.slice(0,3) + '45'
                }
                let indx = this.opening_time_format.indexOf(temp_start_time)
                this.opening_time_format.splice(0,indx+1)
            }
        },
        checkClosingTime(){
            this.auction_closing_time = "";
            this.closing_time_format = [
                '00:00',
                '00:15',
                '00:30',
                '00:45',
                '01:00',
                '01:15',
                '01:30',
                '01:45',
                '02:00',
                '02:15',
                '02:30',
                '02:45',
                '03:00',
                '03:15',
                '03:30',
                '03:45',
                '04:00',
                '04:15',
                '04:30',
                '04:45',
                '05:00',
                '05:15',
                '05:30',
                '05:45',
                '06:00',
                '06:15',
                '06:30',
                '06:45',
                '07:00',
                '07:15',
                '07:30',
                '07:45',
                '08:00',
                '08:15',
                '08:30',
                '08:45',
                '09:00',
                '09:15',
                '09:30',
                '09:45',
                '10:00',
                '10:15',
                '10:30',
                '10:45',
                '11:00',
                '11:15',
                '11:30',
                '11:45',
                '12:00',
                '12:15',
                '12:30',
                '12:45',
                '13:00',
                '13:15',
                '13:30',
                '13:45',
                '14:00',
                '14:15',
                '14:30',
                '14:45',
                '15:00',
                '15:15',
                '15:30',
                '15:45',
                '16:00',
                '16:15',
                '16:30',
                '16:45',
                '17:00',
                '17:15',
                '17:30',
                '17:45',
                '18:00',
                '18:15',
                '18:30',
                '18:45',
                '19:00',
                '19:15',
                '19:30',
                '19:45',
                '20:00',
                '20:15',
                '20:30',
                '20:45',
                '21:00',
                '21:15',
                '21:30',
                '21:45',
                '22:00',
                '22:15',
                '22:30',
                '22:45',
                '23:00',
                '23:15',
                '23:30',
                '23:45',
            ]
            if(this.auction_opening_date == this.auction_closing_date){
                var temp_start_time = ""
                var curr_time = this.auction_opening_time
                if(parseInt(curr_time.substring(3)) >= 0 && parseInt(curr_time.substring(3)) < 15){
                    temp_start_time = curr_time.slice(0,3) + '00'
                } else if(parseInt(curr_time.substring(3)) >= 15 && parseInt(curr_time.substring(3)) < 30){
                    temp_start_time = curr_time.slice(0,3) + '15'
                } else if(parseInt(curr_time.substring(3)) >= 30 && parseInt(curr_time.substring(3)) < 45){
                    temp_start_time = curr_time.slice(0,3) + '30'
                } else if(parseInt(curr_time.substring(3)) >= 45){
                    temp_start_time = curr_time.slice(0,3) + '45'
                }
                let indx = this.closing_time_format.indexOf(temp_start_time)
                this.closing_time_format.splice(0,indx+1)
            }
        },
    },
    mounted(){
        if(localStorage.getItem("auction_template_data")){
            this.auction_template_data = JSON.parse(localStorage.getItem("auction_template_data"))
            this.auction_name = this.auction_template_data.auction_info.auction_name
            this.auction_creator = this.auction_template_data.auction_creator_name
            this.creation_date = moment(new Date().toUTCString()).format("MM-DD-YYYY"),
            this.auction_opening_date = this.auction_template_data.auction_info.auction_opening_date
            this.auction_opening_time = this.auction_template_data.auction_info.auction_opening_time
            this.auction_closing_date = this.auction_template_data.auction_info.auction_closing_date
            this.auction_closing_time = this.auction_template_data.auction_info.auction_closing_time
            this.description = this.auction_template_data.auction_info.description
            this.auction_table = this.auction_template_data.table_info.table_details
        }
        this.auction_creator = this.loggedInUser.full_name;
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    },
}
</script>
<style scoped>
    .create-auction-container {
        background-color: #fff;
        padding: 15.5px 0 0px 0;
        border-radius: 6px;
    }
    .create-auction-header {
        padding: 9.9px 15px;
        background-color: #00448b;
    }
    .main-div {
        background: #fff;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .input-label {
        font-weight: 600;
        line-height: 1.5;
        letter-spacing: 0.39px;
        text-align: left;
        color: #00448b;
        padding: 0 0 6px 0px;
        font-size: 14px;
    }
    .input-field {
        border-radius: 6px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        color: black;
        font-size: 14px !important;
        font-weight: 600;
    }
    .table-input-field {
        border-bottom: 0px solid #fff !important;
        padding: 10px 16px 4px 10px !important;
        margin-left: 15px !important;
        width: 20% !important;
        color: #fff !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        background-color: #00448b !important;
    }
    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }
    .btn-new-preview{
        padding: 0 10px !important;
		border-radius: 5px !important;
		font-size: 14px !important;
		line-height: 30px !important;
		text-transform: none !important;
		font-weight: 600 !important;
		color: #fff !important;    
	    background-color: #00448b !important;
    }
    .table-div{
        border: 1px solid black;
        border-radius: 5px;
        height: auto;
    }
    .btn-add{
        padding: 0 10px !important;
		border-radius: 5px !important;
		font-size: 14px !important;
        width: 150px;
		text-transform: none !important;
		font-weight: 600 !important;
		color: #fff !important;    
	    background-color: #1E7209 !important;
        margin-top: 12px;
        float: right;
    }
    .disable-btn{
        background-color: #848484 !important;
    }
    .btn-new-add{
        padding: 0 10px !important;
		border-radius: 5px !important;
		font-size: 14px !important;
        width: 150px;
		text-transform: none !important;
		font-weight: 600 !important;
		color: #fff !important;    
	    background-color: #00448b !important;
        margin-top: 12px;
        float: right;
    }
    .table-name-section{
        height: 40px !important;
        background-color: #00448b !important;
    }
    @media only screen and (min-width: 0px) and (max-width: 767px) {
        .row-padding-right{
            padding-right: 36px !important;
        }
    }
    .auction-data-table>tbody>tr:first-child td, .auction-data-table>tbody>tr:first-child td input {
        background: #fff !important;
        color: #303031 !important;
        border-bottom: 0px solid #fff !important;
    }
    .auction-data-table tbody tr td input {
        font-weight: 600;
        text-align: left !important;
        border-bottom: 0px solid #000 !important;
    }
    .table-list:disabled{
        background-color: #fff !important
    }
    input:disabled{
        cursor: no-drop;
    }
    .auction-data-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        border: 1px solid #000 !important
    }
    .auction-data-table thead tr th:first-child {
        border-top-left-radius: 5px;
    }
    .auction-data-table thead tr th:last-child {
        border-top-right-radius: 5px;
    }
    .auction-data-table>tbody>tr:first-child td input::placeholder{
        color: #7b7f83 !important;
    }
    .auction-data-table>tbody>tr:first-child td {
         border-bottom: 0.5px solid #303031 !important;
    }
    .new-back-button{
		padding: 0 10px !important;
		border-radius: 5px !important;
		font-size: 14px !important;
		line-height: 30px !important;
		text-transform: none !important;
		font-weight: 600 !important;
		color: #00448b !important;    
	    background-color: #fff !important;
    	border: 1px solid #00448b !important;
	}
	.new-back-button:hover{
		background-color: #00448b !important;
		color: #fff !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/Auction/EditPreviewAuction.vue